var exports = {
  "k": "x93eb46d8--699c3f--container",
  "x": "x93eb46d8--699c3f--container--pessimized",
};

module.exports = exports;
